import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { faClose } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import { colors } from '@seeqdev/qomponents/colors.stylex';
import type { AutoUpdateTimeScheduleEntry } from '@/schedule/schedule.types';

interface AutoUpdateTimeSchedulePropertiesProps {
  isInvalid: boolean;
  showRemoveIcon: boolean;
  entry: AutoUpdateTimeScheduleEntry;
  onChange: (updateTime: AutoUpdateTimeScheduleEntry) => void;
  onClickRemove: () => void;
  disabled?: boolean;
}

export const AutoUpdateTimeScheduleProperties = ({
  entry,
  onChange,
  isInvalid,
  showRemoveIcon,
  onClickRemove,
  disabled = false,
}: AutoUpdateTimeSchedulePropertiesProps) => {
  const { t } = useTranslation();
  const validationMessageId = useId();

  const onChangeTime = (newTime: string) => {
    if (newTime) {
      return onChange({ ...entry, time: newTime });
    }
  };

  return (
    <div
      className={clsx('flexColumnContainer', stylex.props(styles.scheduleEntry).className)}
      data-testid="time-schedule-entry">
      <input
        type="time"
        data-testid="time-schedule-entry__time"
        className={clsx(
          'noValidationIcons form-control organizerScheduleTime',
          isInvalid ? 'is-invalid' : '',
          stylex.props(styles.timeInput).className,
        )}
        aria-invalid={isInvalid || undefined}
        aria-describedby={isInvalid ? validationMessageId : undefined}
        value={entry.time}
        onChange={(e) => onChangeTime(e.target.value)}
        required={true}
        disabled={disabled}
      />
      {isInvalid ? (
        <span id={validationMessageId} className="sr-only">
          {t('SCHEDULE_TYPE.INVALID_TIME')}
        </span>
      ) : null}

      {showRemoveIcon && !disabled ? (
        <Icon
          testId="time-schedule-entry__remove"
          extraClassNames="scheduleTimeStrategy"
          xstyle={styles.removeSchedule}
          onClick={onClickRemove}
          icon={faClose}
          large={true}
        />
      ) : null}
    </div>
  );
};

const styles = stylex.create({
  removeSchedule: { lineHeight: '32px', color: colors.mutedForeground, cursor: 'pointer' },
  timeInput: { marginRight: '.3125rem' },
  scheduleEntry: { width: 150, marginBottom: '0.9375rem' },
});
